var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTempest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 274 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M58.29 56.989c-5.815 3.038-12.678 3.981-19.436 1.886-.996-.262-1.991-.734-2.882-1.153-3.772-1.834-6.496-4.505-7.177-5.239 6.706-.471 14.774-2.777 22.056-8.801 1.31-1.1 2.567-2.306 3.615-3.563l1.938 6.392 2.62 8.749c.419 1.047.157 1.257-.734 1.729Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M16.53 31.055c.42-3.93 1.781-7.544 3.772-10.74L14.854 2.084c-.314-1.048-1.153-.839-1.362-.734-.053 0-.105.053-.157.105-.21.157-6.444 6.182-8.592 9.902-3.3 5.92-6.55 25.618 14.773 34.105-2.462-4.139-3.614-9.168-2.986-14.407Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M34.292.302C17.003 2.659 5.425 19.634 9.25 34.669c3.667 15.141 25.304 19.647 39.554 10.478-8.173 4.873-18.599 3.091-22.423-4.977-3.51-7.439.471-16.712 8.12-21.322 2.882-1.73 6.13-2.724 9.483-2.777 13.988-.157 19.174 15.403 9.01 25.828 4.192-3.929 7.335-9.01 8.435-14.774C64.52 11.356 51.685-2.213 34.292.302Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M51.95 9.155c-1.94-.733-4.035-1.205-6.183-1.467-14.302-1.519-27.714 9.22-29.233 23.418-.262 2.41-.21 4.82.262 7.073 2.462 13.045 16.24 21.899 28.028 16.712C55.093 50.333 63.108 40.798 64.68 29.43c1.047-8.016-2.986-16.555-12.73-20.275Zm6.181 22.79c-1.624 10.216-12.73 18.022-22.999 15.402-6.863-1.781-11.002-8.12-9.85-15.402 1.415-9.169 10.583-16.398 19.909-15.874 8.592.523 14.25 7.491 12.94 15.874Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M48.805 40.327c-7.125 6.391-18.913 9.692-27.61 8.487-7.806-1.048-13.15-4.558-16.503-9.22l-.052-.053c-6.13-8.592-5.868-26.09 8.225-37.616.105-.105.524-.419.524-.419C9.984 4.596-.127 18.323 5.48 29.377c3.667 7.335 12.206 9.954 20.484 9.273 6.706-.471 12.52-3.143 16.921-6.968.053 0 .053-.052.105-.052C56.35 20.314 56.506 2.082 39.427.04c.523 0 1.938 0 4.558.523 2.986.576 7.282 2.934 9.377 5.082 8.173 8.12 7.335 24.099-4.557 34.682Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M53.103 43.419C41.944 54.263 26.49 55.992 14.86 52.063c-5.71-1.938-10.53-5.187-13.516-9.378-.158-.262-.891-1.205.419-1.78l3.667-1.677c.471-.262.733-.367 1.52.314 4.819 4.505 11.525 6.601 18.178 6.444 28.186-.734 40.602-30.648 25.986-41.964-2.148-1.73-5.501-2.986-7.178-3.51l.262.052c3.982.786 7.544 2.358 10.53 4.558 11.526 9.692 9.064 27.871-1.624 38.297Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M54.724 5.175a20.762 20.762 0 0 0-3.038-1.886c3.824 2.515 6.13 5.553 7.491 8.068 4.977 8.906 2.62 20.484-4.61 28.762-1.152 1.257-2.305 2.462-3.615 3.562-7.282 6.078-15.35 8.33-22.056 8.802a38.096 38.096 0 0 1-6.024-.052c-.943-.105-1.415.419-1.625.628l-2.043 2.253c-.89 1.048-.471 1.676.367 1.886 5.448 1.414 11.107 1.467 16.398.419 3.72-.733 7.282-1.938 10.582-3.615 3.72-1.886 7.073-4.505 9.85-7.544 4.348-4.715 7.334-10.635 8.225-17.131 1.414-9.902-2.62-18.808-9.902-24.152Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    fill: "#111",
    d: "M96.785 45.645V17.78h10.967v-5.084h-27.63v5.084h11.015v27.864h5.648Zm22.024.706c5.883 0 10.072-3.248 11.343-8.614h-5.413c-.847 2.495-3.012 3.907-5.883 3.907-4.236 0-6.966-2.966-7.343-7.343h18.733v-1.318c-.141-8.096-4.848-13.038-11.908-13.038-6.966 0-12.379 5.083-12.379 13.32 0 7.626 5.225 13.086 12.85 13.086Zm-7.061-15.957c.848-3.577 3.295-5.742 6.59-5.742 3.248 0 5.46 2.165 6.166 5.742h-12.756Zm28.387 15.25V30.535c.047-3.294 2.447-5.79 6.26-5.79 2.683 0 4.377 1.79 4.377 4.567v16.332h5.554V30.535c.047-3.294 2.448-5.79 6.261-5.79 2.682 0 4.377 1.79 4.377 4.567v16.332h5.601V29.03c0-5.366-3.342-9.084-8.566-9.084-3.954 0-7.155 2.024-8.567 4.66-1.318-2.872-4.048-4.66-7.625-4.66-3.719 0-6.778 1.788-8.331 4.236l-.424-3.483h-4.471v24.947h5.554Zm43.394 9.414V42.161c1.694 2.59 4.659 4.19 8.237 4.19 6.636 0 11.296-5.46 11.296-13.321 0-7.72-4.66-13.085-11.249-13.085-3.954 0-7.202 1.93-8.849 4.848l-.565-4.095h-4.472v34.36h5.602Zm7.013-13.414c-4.142 0-7.013-3.625-7.013-8.755 0-4.848 2.871-8.237 6.966-8.237 4.095 0 6.872 3.436 6.872 8.378 0 5.084-2.777 8.614-6.825 8.614Zm28.38 4.707c5.884 0 10.073-3.248 11.344-8.614h-5.413c-.847 2.495-3.013 3.907-5.884 3.907-4.236 0-6.966-2.966-7.342-7.343h18.733v-1.318c-.141-8.096-4.848-13.038-11.908-13.038-6.967 0-12.38 5.083-12.38 13.32 0 7.626 5.225 13.086 12.85 13.086Zm-7.06-15.957c.847-3.577 3.295-5.742 6.59-5.742 3.247 0 5.46 2.165 6.166 5.742h-12.756Zm32.764 15.957c6.118 0 9.602-2.825 9.602-7.437 0-4.472-2.966-5.978-7.908-7.626l-3.012-.988c-1.789-.612-3.954-1.13-3.954-3.06 0-1.694 1.412-2.73 3.859-2.73 2.872 0 4.896 1.318 5.178 4.143h5.272c-.659-5.649-4.613-8.708-10.402-8.708-5.978 0-9.367 2.918-9.367 7.343 0 4.612 3.577 6.024 7.719 7.39l3.295 1.082c2.165.706 3.765 1.083 3.765 3.013s-1.506 3.012-4.33 3.012c-3.059 0-5.366-1.412-5.554-4.095h-5.366c.33 5.46 4.378 8.66 11.203 8.66Zm27.176-.706v-4.707h-2.824c-2.071 0-3.154-1.177-3.154-3.295V25.405h6.449v-4.707h-6.449v-8.52h-5.554v8.52h-4.377v4.707h4.377v12.614c0 4.943 2.918 7.626 8.331 7.626h3.201Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 58.526,
    x2: 40.102,
    y1: 50.03,
    y2: 50.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8669F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.102,
    x2: 19.66,
    y1: 31.043,
    y2: 8.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#724FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#7A51D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#9055CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE5BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 15.549,
    x2: 52.924,
    y1: 38.907,
    y2: 12.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#8669F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#4A3378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.476,
    x2: 57.216,
    y1: 44.415,
    y2: 19.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#907FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F419A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 10.318,
    x2: 47.812,
    y1: 41.533,
    y2: 4.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9689F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#BA82DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#E579C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#F576BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#F569AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F569AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 12.83,
    x2: 59.579,
    y1: 52.169,
    y2: 12.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E64DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A159EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#E959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F55196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 20.142,
    x2: 62.233,
    y1: 49.138,
    y2: 19.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#905DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#9A59CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#B64EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#E03D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#E03D8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTempest);
export default __webpack_public_path__ + "static/media/logo-tempest.7dde07a4e62c5d8b5e8c9400d6da8de7.svg";
export { ForwardRef as ReactComponent };